'use strict';

class CookieManager {
    static setCookie(name, value) {
        const expires = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; Secure; SameSite=Strict';
    }

    static delArtFromCookie(cookieName, article) {
        let articles = CookieManager.getCookie(cookieName) ? JSON.parse(CookieManager.getCookie(cookieName)) : [];
        const index = articles.indexOf(article);
        if (index > -1) {
            articles.splice(index, 1);
        } else {
            return articles.length;
        }
        this.setCookie(cookieName, JSON.stringify(articles));
        TimeCity.favoriteCompareManager.updateActiveItems();
        return articles.length;
    }

    static getCookie(name) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    }
}

class FavoriteCompareManager {
    constructor() {
        this.currentFavorites = CookieManager.getCookie('favorite') ? JSON.parse(CookieManager.getCookie('favorite')) : [];
        this.currentCompares = CookieManager.getCookie('compare') ? JSON.parse(CookieManager.getCookie('compare')) : [];
        document.addEventListener('DOMContentLoaded', () => this.initializeEventHandlers());
        try {
            BX.addCustomEvent('onAjaxSuccessFinish', () => {
                TimeCity.favoriteCompareManager.initializeEventHandlers();
            });
        } catch (error) {
            console.warn('BX is not defined. Custom events will not be registered.', error);
        }
    }

    initializeEventHandlers() {
        this.updateActiveItems();
        document.querySelectorAll('.fc__favorite:not([data-init]), .fc__compare:not([data-init])').forEach(item => {
            // Для исключения повторного добавления события на один и тот же элемент
            item.dataset.init = '';
            const article = item.parentElement.dataset.art;
            const isFavorite = item.classList.contains('fc__favorite');
            const isChart = item.classList.contains('fc__compare');

            if (isFavorite || isChart) {
                item.addEventListener('click', () => {
                    const cookieName = isFavorite ? 'favorite' : 'compare';
                    let array = CookieManager.getCookie(cookieName) ? JSON.parse(CookieManager.getCookie(cookieName)) : [];

                    const index = array.indexOf(article);
                    if (index > -1) {
                        array.splice(index, 1);
                    } else {
                        array.push(article);
                    }

                    CookieManager.setCookie(cookieName, JSON.stringify(array));
                    this.updateActiveItems();

                    // Цель яндекс метрики
                    if (ym) {
                        let id
                        if (isFavorite) {
                            id = 'c_dobavit_v_izbrannoe';
                        } else if (isChart) {
                            id = 'c_dobavit_v_sravnenie';
                        }
                        ym(44099011, 'reachGoal', id);
                    }
                });
            }
        });

        /**
         * только для страницы сравнения
         */
        document.querySelectorAll('.reset-link').forEach(item => {
            item.addEventListener('click', () => {
                document.cookie = 'compare=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure; SameSite=Strict';
                this.goToCatalog()
            })
        })

        /**
         * только для страницы сравнения
         */
        document.querySelectorAll('.compare_item .round-icon-buttons__item [*|href$=".svg#chart"]').forEach(item => {
            let button = item.closest('.round-icon-buttons__item');
            if (!button) {
                return;
            }

            button.addEventListener('click', () => {
                let elementId = button.closest('[data-element-id]').dataset.elementId;
                document.querySelectorAll('[data-element-id="' + elementId + '"]').forEach(element => {
                    element.remove();
                });
            });
        });

        /**
         * только для страницы сравнения
         */
        if (document.getElementById('compare_diff')) { // Проверка на существование элемента, чтобы избежать ошибок на других страницах
            document.getElementById('compare_diff').addEventListener('change', (event) => {
                let display = event.target.checked ? 'none' : null;
                let sameElements = document.querySelectorAll('[data-same=true]');
                sameElements.forEach(element => {
                    element.style.display = display;
                });
            });
        }
    }

    updateActiveItems() {
        this.currentFavorites = CookieManager.getCookie('favorite') ? JSON.parse(CookieManager.getCookie('favorite')) : [];
        this.currentCompares = CookieManager.getCookie('compare') ? JSON.parse(CookieManager.getCookie('compare')) : [];

        document.querySelectorAll('.fc__favorite, .fc__compare').forEach(item => {
            const article = item.parentElement.dataset.art;
            const isFavorite = item.classList.contains('fc__favorite');
            const isChart = item.classList.contains('fc__compare');

            if (isFavorite) {
                if (this.currentFavorites.includes(article)) {
                    item.classList.add('fc__favorite_active');
                } else {
                    item.classList.remove('fc__favorite_active');
                }
            } else if (isChart) {
                if (this.currentCompares.includes(article)) {
                    item.classList.add('fc__compare_active');
                } else {
                    item.classList.remove('fc__compare_active');
                }
            }
        });
        this.updateHeaderIcons();
    }

    updateHeaderIcons() {
        const headerIcons = ['heart', 'chart'];
        const parentClasses = ['header', 'navigation-menu'];
        parentClasses.forEach(parentClass => {
            headerIcons.forEach(iconName => {
                let headIcon = document.querySelector('.' + parentClass + '_compare-favorite [*|href*=".svg"]:is([*|href$="#' + iconName + '"])').closest('.' + parentClass + '_compare-favorite__link');
                let count = iconName === 'heart' ? this.currentFavorites.length : this.currentCompares.length;

                let headBlock = headIcon.closest('.' + parentClass + '_compare-favorite');
                let headIconCountDiv = headIcon.querySelector('.' + parentClass + '_compare-favorite__count');
                if (count) {
                    if (!headIconCountDiv) {
                        headIconCountDiv = document.createElement('div');
                        headIconCountDiv.className = parentClass + '_compare-favorite__count';
                        headIcon.insertBefore(headIconCountDiv, headIcon.firstChild);
                    }
                    headIconCountDiv.textContent = count;
                    headBlock.classList.remove(parentClass + '_compare-favorite_disabled')
                } else {
                    if (headIconCountDiv) {
                        headIconCountDiv.remove();
                    }
                    headBlock.classList.add(parentClass + '_compare-favorite_disabled');
                }
            });
        });
    }

    goToCatalog() {
        const lastVisitedCatalog = CookieManager.getCookie('lastVisitedCatalog');
        window.location.href = lastVisitedCatalog ? BX.message('SITE_DIR') + lastVisitedCatalog + '/' : BX.message('SITE_DIR') + 'catalog/';

    }
}

// Сохранение последнего посещенного каталога в куки
document.addEventListener('DOMContentLoaded', function () {
    const currentPathname = window.location.pathname;
    const siteDir = BX.message('SITE_DIR');

    const catalogPrefix = siteDir + 'catalog/';
    const montblancPrefix = siteDir + 'montblanc/';
    const chasyPrefix = siteDir + 'chasy-s-probegom/';

    let lastCatalog = null;

    if (currentPathname.startsWith(catalogPrefix)) {
        lastCatalog = 'catalog';
    } else if (currentPathname.startsWith(montblancPrefix)) {
        lastCatalog = 'montblanc';
    } else if (currentPathname.startsWith(chasyPrefix)) {
        lastCatalog = 'chasy-s-probegom';
    }

    if (lastCatalog) {
        CookieManager.setCookie('lastVisitedCatalog', lastCatalog);
    }
});

// Инициализация
window.TimeCity = window.TimeCity || {};
window.TimeCity.favoriteCompareManager = new FavoriteCompareManager();
window.TimeCity.cookieManager = CookieManager;